/* eslint-disable */
export const selectChapters = state => state.chapters;
